var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path3, _path4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 20,
    fill: "#FEF0F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 39.0981V36.9183C76 35.8338 75.461 34.8202 74.5619 34.2138L61.9733 25.7238L48.5926 15.9207C46.752 14.5722 44.2488 14.5757 42.4119 15.9292L30.0053 25.0714L16.439 34.2139C15.5394 34.8202 15 35.8341 15 36.919V39.0981H76Z",
    fill: "#F51436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 38.4434H76V73.0209C76 75.1828 74.2474 76.9353 72.0856 76.9353H18.9144C16.7526 76.9353 15 75.1828 15 73.0209V38.4434Z",
    fill: "#F51436"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5669,
    y: 13,
    width: 51.5401,
    height: 54.8021,
    rx: 5.21925,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.4814,
    y: 19.5234,
    width: 16.3102,
    height: 3.26203,
    rx: 1.63102,
    fill: "#2E3031"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.4814,
    y: 26.0469,
    width: 43.7112,
    height: 3.26203,
    rx: 1.63102,
    fill: "#B6B8BA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.4814,
    y: 33.2227,
    width: 43.7112,
    height: 3.26203,
    rx: 1.63102,
    fill: "#B6B8BA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.4814,
    y: 40.4004,
    width: 43.7112,
    height: 3.26203,
    rx: 1.63102,
    fill: "#B6B8BA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 23.4814,
    y: 47.5762,
    width: 43.7112,
    height: 3.26203,
    rx: 1.63102,
    fill: "#B6B8BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 74.6538L40.1176 55.734L15 39.0977V74.6538Z",
    fill: "#F8546C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5561 55.734L76 74.0014V39.0977L50.5561 55.734Z",
    fill: "#F8546C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7459_20469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.4652 70.9176C75.4197 71.5118 76 72.5566 76 73.6809C76 75.4786 74.5427 76.936 72.7449 76.936H18.2681C16.4632 76.936 15 75.4728 15 73.6679C15 72.5501 15.5713 71.5098 16.5147 70.9101L30.3316 62.1255L42.8568 53.609C44.1615 52.7219 45.8713 52.7048 47.1935 53.5655L60.3422 62.1255L74.4652 70.9176Z",
    fill: "#E60A2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7459_20469",
    x: 11,
    y: 47.9316,
    width: 69,
    height: 32.0039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7459_20469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7459_20469",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeEmailIcon);
export default __webpack_public_path__ + "static/media/change-email-icon.9f0fd40473ba3b4e65fbdc828915bcf7.svg";
export { ForwardRef as ReactComponent };